import { render, staticRenderFns } from "./ClassTrial.vue?vue&type=template&id=bd3c4864&scoped=true"
import script from "./ClassTrial.vue?vue&type=script&lang=js"
export * from "./ClassTrial.vue?vue&type=script&lang=js"
import style0 from "./ClassTrial.vue?vue&type=style&index=0&id=bd3c4864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3c4864",
  null
  
)

export default component.exports